<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px">
        <v-layout row style="padding: 0px">
          <!-- <v-flex md6>
            <v-form ref="form">
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search by Card No."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-form>
          </v-flex> -->

          <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="getData()"
            >
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <span>Play</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="openGenerateFraudDialog()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M11,19A6,6 0 0,0 17,13H19A8,8 0 0,1 11,21A8,8 0 0,1 3,13A8,8 0 0,1 11,5V7A6,6 0 0,0 5,13A6,6 0 0,0 11,19M19,5H22V7H19V10H17V7H14V5H17V2H19V5Z"
                />
              </svg>
            </v-btn>
            <span>Request Fraud Summary</span>
          </v-tooltip> -->
          <v-tooltip top>
            <v-btn
              v-if="$moduleAccess('download pdf')"
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadPDF"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z"
                />
              </svg>
            </v-btn>
            <span>Download PDF File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateToMenu"
                :close-on-content-click="false"
                v-model="dateToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="dateToMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>

      <v-divider></v-divider>

      <v-dialog
        v-model="dialogFraudGenerate"
        persistent
        max-width="600"
        @keydown.esc="close"
      >
        <v-card>
          <v-card-title class="title">Generate Fraudulent Report</v-card-title>
          <!-- <v-layout> -->
          <v-flex style="padding: 20px 30px">
            <v-container fill-height v-if="generateLoading">
              <v-layout align-center justify-center>
                <v-progress-circular
                  :size="40"
                  :width="3"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-layout>
            </v-container>
            <v-menu
              v-else
              ref="dateGenerateMenu"
              :close-on-content-click="false"
              v-model="dateGenerateMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date"
                label="Date"
                prepend-inner-icon="event"
                outline
                readonly
              ></v-text-field>

              <v-date-picker
                ref="picker"
                v-model="date"
                :max="dateTo"
                min="1950-01-01"
                @change="checkDate"
                @input="dateGenerateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <!-- </v-layout> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              slot="activator"
              primary
              ref="button"
              depressed
              color="primary"
              :disabled="reportDate"
              @click="generateFraudReport()"
            >
              Generate
            </v-btn>
            <v-tooltip top>
              <v-btn
                class="grey lighten-4 mx-2"
                slot="activator"
                ref="button"
                flat
                @click="closeFraudGenerateDialog()"
              >
                <v-icon color="pink">close</v-icon>
              </v-btn>
              <span>Close</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <action-dialog
        :type="dialogType"
        :title="title"
        :dialog="dialogStatus"
        @closeDialog="closeDialog"
        :loading="dialogLoading"
      >
        <v-container
          grid-list-lg
          fluid
          style="margin: 0px; padding: 0px; width: 100%"
        >
          <v-layout justify-center>
            <v-flex md12>
              <!-- Insert View Dialog Content BELOW-->
              <details-container
                ref="detailsRef"
                :items="viewItems"
                :readOnly="dialogType === 'view'"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </action-dialog>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                header.value === queryParams.order ? 'active' : '',
                'text-xs-' + header.align,
              ]"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-center font-weight-medium">
            {{
              props.item.report_date_scope
                ? $dateFormat(props.item.report_date_scope, "YYYY-MM-DD")
                : "--"
            }}
          </td>
          <td class="text-xs-center font-weight-medium">
            {{ props.item.incident_count }}
          </td>
          <td class="text-xs-center">{{ props.item.report_filename }}</td>
          <td class="text-no-wrap text-xs-center">
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="blue"
                slot="activator"
                style="width: 36px; height:36px"
                @click="downloadExcel(props.item.report_filename)"
              >
                <v-icon style="font-size: 17px;">file_download</v-icon>
              </v-btn>
              <span>Download</span>
            </v-tooltip>
            <!-- |
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="blue"
                slot="activator"
                style="width: 36px; height:36px"
                @click="openDialog(props.item.report_filename)"
              >
                <v-icon style="font-size: 18px;">find_in_page</v-icon>
              </v-btn>
              <span>View</span>
            </v-tooltip> -->
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
import JsPdf from "jspdf";
import "jspdf-autotable";
import DetailsContainer from "@/components/details_container/CardFraudulentContainer.vue";
import moment from "moment";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      dateGenerateMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      dateFrom: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      dateTo: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      date: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      title: "Fraudulent Report",
      bookTitle: "Fraudulent Report",
      items: [],
      items2: [],
      headers: [
        { text: "#", align: "left", value: "#", sortable: false },
        {
          text: "Report Date",
          align: "center",
          value: "report_date_scope",
          sortable: false,
        },
        {
          text: "Incident Count",
          align: "center",
          value: "incedent_count",
          sortable: true,
        },
        {
          text: "Report File Name",
          align: "center",
          value: "report_filename",
          sortable: true,
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          sortable: true,
        },
      ],
      headersExcel: [
        {
          text: "Card",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "transaction_date",
          sortable: true,
        },
        {
          text: "Time",
          align: "center",
          value: "transaction_time",
          sortable: true,
        },
        {
          text: "Control no.",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Or no.",
          align: "left",
          value: "or_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "device_serial",
          sortable: false,
        },
        {
          text: "Location",
          align: "left",
          value: "location",
          sortable: true,
        },
        {
          text: "Terminal",
          align: "left",
          value: "terminal",
          sortable: true,
        },
        {
          text: "Transaction",
          align: "left",
          value: "transaction",
          sortable: false,
        },
        {
          text: "Transaction Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "Previous Balance",
          align: "center",
          value: "previous_balance",
          sortable: false,
        },
        {
          text: "Transaction Count",
          align: "center",
          value: "previous_count",
          sortable: false,
        },
      ],
      queryParams: {
        search: null,
        offset: 0,
        date_from: null,
        date_to: null,
        report_filename: null,
        date: null,
      },
      reportDate: false,
      totalItems: 0,
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewData: {},
      viewItems: [],
      dialogFraudGenerate: false,

      openConfirmDialog: false,
      confirmLoading: false,
      transactionData: null,
      generateLoading: false,
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {},
  created: async function() {
    await this.$store.commit("initiateTempData");
  },
  computed: {
    computedItems() {
      return this.$store.state.tempData;
    },
    searchItem: {
      get() {
        return this.queryParams.search;
      },
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  methods: {
    async getData(reset) {
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.dateTo + " " + this.timeTo + ":59";

      if (reset) {
        this.queryParams.offset = 0;
        await this.$store.commit("initiateTempData");
      }

      try {
        const response = (
          await Services.getTicketingFraudulentSummary(this.queryParams)
        ).data;

        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    refreshData() {
      this.dateFrom = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.getData(true);
    },
    async checkDate() {
      this.queryParams.date = this.date;

      try {
        const response = (await Services.checkReportDate(this.queryParams))
          .data;

        this.reportDate = response.checkReportDate;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
    },
    async openDialog(data) {
      this.viewItems = [];
      this.dialogLoading = true;
      this.dialogType = "view";
      this.dialogStatus = true;
      this.queryParams.report_filename = data;

      try {
        const response = (await Services.getCardFraudulent(this.queryParams))
          .data;

        this.viewItems = response;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }

        if (error) {
          this.$infoBar({
            type: "error",
            text: "No file found",
          });
          this.dialogStatus = false;
        }
      }

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    async openGenerateFraudDialog() {
      this.dialogType = "view";
      this.dialogFraudGenerate = true;
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeFraudGenerateDialog() {
      this.$emit("input", false);
      this.dialogType = "";
      this.dialogFraudGenerate = false;
    },
    async generateFraudReport() {
      this.$store.dispatch("startLoading");
      this.generateLoading = true;
      this.reportDate = true;

      this.queryParams.date_from = this.date + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.date + " " + this.timeTo + ":59";

      let response;

      try {
        response = (await Services.generateFraudulentReport(this.queryParams))
          .data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
        this.generateLoading = false;
      }

      if (response && response.data.report_filename) {
        this.generateLoading = false;
        this.closeFraudGenerateDialog();
        this.openDialog(response.data.report_filename);
      } else {
        this.generateLoading = false;
        this.reportDate = false;
        this.$infoBar({
          type: "error",
          text: "No Report Found!",
        });
      }
      this.$store.dispatch("endLoading");
    },
    async downloadExcel(data) {
      this.$store.dispatch("startLoading");
      this.queryParams.report_filename = data;
      this.items2 = [];

      if (data && typeof data == "string") {
        this.bookTitle = data.replace("fraud-report", "Fraudulent-Report");
      }
      try {
        const rawResponse = await Services.getCardFraudulent(this.queryParams);
        console.log("[downloadExcel] status:", rawResponse.status);
        console.log("[downloadExcel] response.data type:", typeof rawResponse.data, Array.isArray(rawResponse.data));
        console.log("[downloadExcel] response.data sample:", JSON.stringify(rawResponse.data).substring(0, 300));

        const response = rawResponse.data;

        // API returns array-of-arrays (csvtojson output:"csv"):
        // row[0] is the header row, subsequent rows are data
        if (Array.isArray(response)) {
          this.items2 = response;
        } else if (response && Array.isArray(response.data)) {
          this.items2 = response.data;
        } else {
          this.items2 = [];
          console.warn("[downloadExcel] Unexpected response shape:", response);
        }

        console.log("[downloadExcel] items2 length:", this.items2.length);
        console.log("[downloadExcel] items2[0]:", JSON.stringify(this.items2[0]));
        console.log("[downloadExcel] items2[1]:", JSON.stringify(this.items2[1]));
      } catch (error) {
        console.error("[downloadExcel] error:", error);
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "No file found",
          });
        }
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      if (!this.items2 || this.items2.length === 0) {
        this.$infoBar({
          type: "error",
          text: "No data found for the selected file.",
        });
        return;
      }

      var wscols = [
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
      ];

      var wsrows = [];

      // items2 is already an array-of-arrays from the API (csvtojson output:"csv")
      // Row 0 is the CSV header row, the rest are data rows — pass directly to aoa_to_sheet
      var ws = XLSX.utils.aoa_to_sheet(this.items2, { cellDates: true });
      var wb = XLSX.utils.book_new();

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.bookTitle,
        Subject: this.bookTitle,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      XLSX.writeFile(wb, this.bookTitle + ".xlsx");
    },
    downloadPDF() {
      if (!this.items || this.items.length === 0) {
        this.$infoBar({
          type: "error",
          text: "No data to export.",
        });
        return;
      }

      const doc = new JsPdf({ orientation: "landscape" });
      doc.setFontSize(14);
      doc.text(this.title, 14, 15);

      const columns = this.headers
        .filter((h) => h.value !== "action")
        .map((h) => ({ header: h.text, dataKey: h.value || h.text }));

      const rows = this.items.map((item, index) => ({
        "#": index + 1,
        report_date_scope: item.report_date_scope
          ? this.$dateFormat(item.report_date_scope, "YYYY-MM-DD")
          : "--",
        incedent_count: item.incident_count,
        report_filename: item.report_filename,
      }));

      doc.autoTable({
        columns,
        body: rows,
        startY: 20,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [255, 179, 0] },
      });

      doc.save(this.title + ".pdf");
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
/* table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
} */
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.form {
  padding: 0px 5px 10px 5px;
  border: 2px solid gray;
  border-radius: 5px;
}
.form:hover {
  border: 2px solid black;
}
#styled-input {
  height: 10px !important;
  font-size: 10pt !important;
}
</style>
